import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import makeAjaxRequest from "helpers/makeAjaxRequest";
import { pRostDataServiceUrl, rootUrl } from "../actions/constants";
const initialState = {
  associationLov: [],
  personRoleEnum: [],
  browse: [],
  selectedRow: null,
  associationFilterInput: "",
  selectedObjectTypeFilter: { label: "All", value: "" },
  selectedAssociationFilter: { label: "All", value: "" },
  associationLovAll: null,
  participants: null,
  selectedPR: null,
  roleTypeLov: null,
  roleNameLov: null,
  affilationLov: null
};

const manageCommitteeState = state => state.manageCommittee;

export const manageCommitteeSelector = createSelector(
  [manageCommitteeState],
  (manageCommitteeState) => manageCommitteeState.browse
);

export const selectedObjectTypeFilterSelector = createSelector(
  [manageCommitteeState],
  (manageCommitteeState) => manageCommitteeState.selectedObjectTypeFilter
);
export const selectedAssociationFilterSelector = createSelector(
  [manageCommitteeState],
  (manageCommitteeState) => manageCommitteeState.selectedAssociationFilter
);
export const associationLovSelector = createSelector(
  [manageCommitteeState],
  (manageCommitteeState) => {
    return manageCommitteeState.associationLov;
  }
);
export const personRoleEnumSelector = createSelector(
  [manageCommitteeState],
  (manageCommitteeState) => manageCommitteeState.personRoleEnum
);

export const participantsSelector = createSelector(
  [manageCommitteeState],
  (manageCommitteeState) => manageCommitteeState.participants
);

export const selectedMCSelector = createSelector(
  [manageCommitteeState],
  (manageCommitteeState) => manageCommitteeState.selectedRow || {}
);

export const selectedPRSelector = createSelector(
  [manageCommitteeState],
  (manageCommitteeState) => manageCommitteeState.selectedPR
);
export const roleTypeLovSelector = createSelector(
  [manageCommitteeState],
  (manageCommitteeState) => manageCommitteeState.roleTypeLov
);
export const roleNameLovSelector = createSelector(
  [manageCommitteeState],
  (manageCommitteeState) => manageCommitteeState.roleNameLov
);
export const affilationLovSelector = createSelector(
  [manageCommitteeState],
  (manageCommitteeState) => manageCommitteeState.affilationLov || []
);

export const fetchAssociationLov = createAsyncThunk(
  "managecommittee/associationlov",
  async (params, { getState, dispatch }) => {
    const state = getState();
    const associationLovAll = state.manageCommittee.associationLovAll;
    if (params.association === "All" && params.objtype === "All" && associationLovAll) {
      return associationLovAll;
    }
    if ((params.objtype === "All" || params.objtype === "") && associationLovAll) {
      if (params.association && params.association.length > 0) {
        return associationLovAll?.filter(option =>
          option.value.toLowerCase().includes(params.association.toLowerCase())
        );
      } else {
        return associationLovAll;
      }
    }

    try {
      const response = await makeAjaxRequest.fetchWithAuth(
        `${rootUrl}/admin/managecommittee/${params.association}/associationlov/${params.objtype}`
      );
      const filteredResponse = response?.filter(option => option.value !== "All");

      if (params.association === "All" && params.objtype === "All") {
        dispatch(setAssociationLovAll(filteredResponse));
      }
      console.log(filteredResponse);
      return filteredResponse;
    } catch (err) {
      throw err.response ? err.response.data : err.message;
    }
  }
);

export const fetchPersonRoleEnum = createAsyncThunk(
  "managecommittee/personroleenum",
  async (id, { rejectWithValue }) => {
    if (!id) {
      return [];
    }
    try {
      const response = await makeAjaxRequest.fetchWithAuth(
        `${rootUrl}/admin/managecommittee/${id}/personroleenum`
      );
      return response;
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);
export const fetchRoleTypeLov = createAsyncThunk(
  "managecommittee/RoleTypeLov",
  async (owner, { rejectWithValue }) => {
    try {
      const response = await makeAjaxRequest.fetchWithAuth(
        `${pRostDataServiceUrl}/persons/${owner}/rosterrolesroletypes`
      );
      return response;
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);
export const fetchRoleNameLov = createAsyncThunk(
  "managecommittee/RoleNameLov",
  async (params, { rejectWithValue }) => {
    const { owner, objectType } = params;
    if (!objectType) {
      return [];
    }
    try {
      const response = await makeAjaxRequest.fetchWithAuth(
        `${pRostDataServiceUrl}/persons/${owner}/${objectType}/rosterrolesrolenames`
      );
      return response;
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);
export const fetchAffilationLov = createAsyncThunk(
  "managecommittee/affilationLov",
  async (personObj, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await makeAjaxRequest.fetchWithAuth(
        `${rootUrl}/admin/managecommittee/${personObj?.owner}/participants/${personObj?.perId}/sitectepidlov`
      );
      const data = response?.map((obj) => ({
        ...obj,
        label: obj?.siteCtepId,
        value: obj?.siteCtepId
      }));
      return fulfillWithValue(data);
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);
export const fetchMCParticipants = createAsyncThunk(
  "managecommittee/participant",
  async (dataObj, { rejectWithValue }) => {
    if (!dataObj || !dataObj.forObjDbId) {
      return {};
    }

    const postBody = {
      "filter": [
        {
          "field": "forObjDbId",
          "operation": "=",
          "value": dataObj.forObjDbId
        },
        {
          "field": "roleId",
          "operation": "=",
          "value": dataObj.roleId
        }
      ],
      "first": 0,
      "isMetaRequired": true,
      "size": 0,
      "sort": []
    };

    try {
      const response = await makeAjaxRequest.postWithAuth(
        `${rootUrl}/admin/managecommittee/participants/browse`,
        postBody
      );
      const { data } = response;
      const d = data?.filter((obj) => obj.personCtepId !== null);
      return { ...response, data: d };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchManageCommittee = createAsyncThunk(
  "managecommittee/browse",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await makeAjaxRequest.postWithAuth(`${rootUrl}/admin/managecommittee/browse`, {});
      const d = response.data || [];
      let data = d.sort((a, b) => a.esysId.localeCompare(b.esysId));
      if (arg && arg.esysId) {
        const index = data.findIndex(item =>
          item.esysId === arg.esysId && item.owner === arg.owner && item.objectType === arg.objectType
        );
        if (index > -1) {
          const [itemWithKey] = data.splice(index, 1);
          data.unshift(itemWithKey);
        }
      }
      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const manageCommitteeSlice = createSlice({
  name: "manageCommittee",
  initialState,
  reducers: {
    saveSelectedMCRow: (state, action) => {
      state.selectedRow = action.payload;
    },
    setSelectedObjectTypeFilter: (state, action) => {
      state.selectedObjectTypeFilter = action.payload;
    },
    setAssociationFilterInput: (state, action) => {
      state.associationFilterInput = action.payload;
    },
    setSelectedAssociationFilter: (state, action) => {
      state.selectedAssociationFilter = action.payload;
    },
    setAssociationLovAll: (state, action) => {
      state.associationLovAll = action.payload;
    },
    saveSelectedPR: (state, action) => {
      state.selectedPR = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAssociationLov.fulfilled, (state, action) => {
      state.associationLov = action.payload;
    });
    builder.addCase(fetchPersonRoleEnum.fulfilled, (state, action) => {
      state.personRoleEnum = action.payload;
    });
    builder.addCase(fetchMCParticipants.fulfilled, (state, action) => {
      state.participants = action.payload;
    });
    builder.addCase(fetchRoleTypeLov.fulfilled, (state, action) => {
      state.roleTypeLov = action.payload;
    });
    builder.addCase(fetchRoleNameLov.fulfilled, (state, action) => {
      state.roleNameLov = action.payload;
    });
    builder.addCase(fetchAffilationLov.fulfilled, (state, action) => {
      state.affilationLov = action.payload;
    });
    builder.addCase(fetchManageCommittee.fulfilled, (state, action) => {
      state.browse = action.payload;
    });
  }
});

export const {
  saveSelectedMCRow,
  setSelectedObjectTypeFilter,
  setAssociationFilterInput,
  setSelectedAssociationFilter,
  setAssociationLovAll,
  saveSelectedPR
} = manageCommitteeSlice.actions;
export default manageCommitteeSlice.reducer;
